<template>
  <div class="main-content" id="mainContent" data-mark-as-prerendered="true"
       style="height: 100vh; position: relative; overflow-y: auto; overflow-x: hidden">
    <div style="position: relative; width: 0; height: 0; z-index: 999999999;">
      <div style="position: absolute; width: 0; height: 100vh; " id="globalPopupGlass">

      </div>
    </div>
    <Navbar></Navbar>
    <b-navbar id="navbar-sizer" toggleable="md" type="dark" variant="dark" fixed="true">
      <b-navbar-brand> &nbsp;</b-navbar-brand>
    </b-navbar>
    <!--router view-->
    <router-view ref="routerView" class="main-view"></router-view>

    <DialogsMountPoint></DialogsMountPoint>
  </div>
</template>


<script>
import SessionManager from "@/utils/SessionManager"
import Navbar from "@/components/dashboard/Navbar";
import DialogsMountPoint from "@/components/dialogs/DialogsMountPoint";
import Rpc from "@/Rpc";

let HomePage = {
  name: "HomePage",
  components: {Navbar, DialogsMountPoint},
  created() {
    HomePage.instance = this;
    Rpc.Interactions.pageView("/dashboard").then();
  },
  mounted() {
    if (SessionManager.inPrerenderMode()) {
      this.$nextTick(() => document.dispatchEvent(new Event('prerender-trigger')));
    }
  },
  methods: {},
  data: () => ({})
};

export default HomePage;
</script>

